<template>
  <v-container fluid>
    <v-container>
      <h1 class="text-h3">{{ $t("controlTitle") }}</h1>
    </v-container>
    <v-container>
      <v-card tile class="d-flex flex-column pa-3">
        <v-expansion-panels focusable>
          <v-expansion-panel
            v-for="location in locationsAll"
            :key="location.id"
          >
            <v-expansion-panel-header
              >{{ location.country.name }}, {{ location.city.name }},
              {{ location.name }}, ID:
              {{ location.id }}</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-simple-table v-if="location.playgrounds.length">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left blue--text">
                        {{ $t("controlPlayground") }}
                      </th>
                      <th class="text-left blue--text">ID</th>
                      <th class="text-left blue--text">
                        {{ $t("controlToken") }}
                      </th>
                      <th class="text-left blue--text">
                        {{ $t("controlTableEnabled") }}
                      </th>
                      <th class="text-left blue--text">
                        {{ $t("controlManage") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <control-table
                      v-for="playground in location.playgrounds"
                      :key="playground.id"
                      :playground="playground"
                      :playground_name="playground.name"
                    ></control-table>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-text v-else>
                <p class="text-center mt-4 mb-0">
                  {{ $t("controlNoPlaygrounds") }}
                </p>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ControlTable from "@/components/ControlTable.vue";

export default {
  name: "Control",

  computed: {
    ...mapGetters(["locationsAll"]),
  },

  methods: {
    ...mapActions(["loadLocationsAll"]),
  },

  components: {
    ControlTable,
  },

  created() {
    this.loadLocationsAll();
    window.setInterval(this.loadLocationsAll, 60000);
  },
};
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
